export default {"src":"/_next/static/media/notabene.9e4c4a97.svg","height":45,"width":141,"blurWidth":0,"blurHeight":0};